import firebase from "../firebase";

export default function({ officeId, arrayVisit, contactData }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingUser",
        funcName: "createVisitMassive",
        data: { officeId, arrayVisit, contactData }
    });
}
